import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20collage%20featuring%20varied%20clothing%20pieces%20including%20sneakers%20hoodies%20denim%20jackets%20caps%20and%20leather%20accessories%20artistically%20scattered%20on%20pristine%20white%20marble%20surface%20with%20soft%20natural%20morning%20light%20streaming%20through%20large%20windows%20creating%20gentle%20shadows%20editorial%20product%20photography%20style%20with%20fresh%20spring%20atmosphere%20harmonious%20warm%20beige%20cream%20and%20ivory%20tones%20organic%20composition%20with%20negative%20space%20contemporary%20minimalist%20design%20aesthetic&width=1800&height=1000&seq=hero-main-v2-2026&orientation=landscape"
        alt="Superbuy Spreadsheet curated fashion products"
        title="Superbuy Spreadsheet - Trusted Shopping Links"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-3xl">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm text-white text-xs md:text-sm font-medium tracking-wide mb-6">
            Trusted Link Directory
          </span>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white leading-none tracking-tight">
            superbuy
            <br />
            spreadsheet
          </h1>

          <p className="mt-6 text-base md:text-lg text-white/80 font-body leading-relaxed max-w-xl mx-auto">
            The most complete and trusted link directory for superbuy shopping.
            <br className="hidden md:block" />
            Verified links, curated categories, updated daily.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 bg-white text-foreground-950 rounded-md font-medium text-sm hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              superbuy spreadsheet
              <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-white text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 bg-accent-500 text-foreground-950 rounded-md font-semibold text-sm hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-white text-sm"></i>
              </span>
            </a>
          </div>

          <Link
            to="/articles/best-superbuy-spreadsheet-2026"
            className="inline-block mt-6 text-white/70 hover:text-white text-sm underline underline-offset-4 transition-colors cursor-pointer"
          >
            Read our complete superbuy spreadsheet guide →
          </Link>
        </div>
      </div>
    </section>
  );
}